/* tslint:disable */
/* eslint-disable */
/**
 * Corrigo API
 * fejlesztői
 *
 * The version of the OpenAPI document: 1.5.2
 * Contact: kerezsigergely@infobex.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
/**
 *
 */
export class FormsApi extends runtime.BaseAPI {
    /**
     *  [ID: GetFormData]
     */
    getFormDataRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['form_scope'] == null) {
                throw new runtime.RequiredError('form_scope', 'Required parameter "form_scope" was null or undefined when calling getFormData().');
            }
            if (requestParameters['resource_id'] == null) {
                throw new runtime.RequiredError('resource_id', 'Required parameter "resource_id" was null or undefined when calling getFormData().');
            }
            if (requestParameters['schema_id'] == null) {
                throw new runtime.RequiredError('schema_id', 'Required parameter "schema_id" was null or undefined when calling getFormData().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/forms/{form_scope}/{resource_id}/{schema_id}`.replace(`{${"form_scope"}}`, encodeURIComponent(String(requestParameters['form_scope']))).replace(`{${"resource_id"}}`, encodeURIComponent(String(requestParameters['resource_id']))).replace(`{${"schema_id"}}`, encodeURIComponent(String(requestParameters['schema_id']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     *  [ID: GetFormData]
     */
    getFormData(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getFormDataRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     *  [ID: GetFormStatusByResourceId]
     */
    getFormStatusByResourceIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['form_scope'] == null) {
                throw new runtime.RequiredError('form_scope', 'Required parameter "form_scope" was null or undefined when calling getFormStatusByResourceId().');
            }
            if (requestParameters['resource_id'] == null) {
                throw new runtime.RequiredError('resource_id', 'Required parameter "resource_id" was null or undefined when calling getFormStatusByResourceId().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/forms/{form_scope}/{resource_id}`.replace(`{${"form_scope"}}`, encodeURIComponent(String(requestParameters['form_scope']))).replace(`{${"resource_id"}}`, encodeURIComponent(String(requestParameters['resource_id']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     *  [ID: GetFormStatusByResourceId]
     */
    getFormStatusByResourceId(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getFormStatusByResourceIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     *  [ID: GetFormsByScope]
     */
    getFormsByScopeRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['form_scope'] == null) {
                throw new runtime.RequiredError('form_scope', 'Required parameter "form_scope" was null or undefined when calling getFormsByScope().');
            }
            const queryParameters = {};
            if (requestParameters['organization_id'] != null) {
                queryParameters['organization_id'] = requestParameters['organization_id'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/forms/{form_scope}`.replace(`{${"form_scope"}}`, encodeURIComponent(String(requestParameters['form_scope']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     *  [ID: GetFormsByScope]
     */
    getFormsByScope(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getFormsByScopeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     *  [ID: GetSchema]
     */
    getSchemaRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['schema_id'] == null) {
                throw new runtime.RequiredError('schema_id', 'Required parameter "schema_id" was null or undefined when calling getSchema().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/forms/schemas/{schema_id}`.replace(`{${"schema_id"}}`, encodeURIComponent(String(requestParameters['schema_id']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     *  [ID: GetSchema]
     */
    getSchema(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSchemaRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Űrlap írása [ID: WriteFormData]
     */
    writeFormDataRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['form_scope'] == null) {
                throw new runtime.RequiredError('form_scope', 'Required parameter "form_scope" was null or undefined when calling writeFormData().');
            }
            if (requestParameters['resource_id'] == null) {
                throw new runtime.RequiredError('resource_id', 'Required parameter "resource_id" was null or undefined when calling writeFormData().');
            }
            if (requestParameters['schema_id'] == null) {
                throw new runtime.RequiredError('schema_id', 'Required parameter "schema_id" was null or undefined when calling writeFormData().');
            }
            const queryParameters = {};
            if (requestParameters['skip_validation'] != null) {
                queryParameters['skip_validation'] = requestParameters['skip_validation'];
            }
            if (requestParameters['merge'] != null) {
                queryParameters['merge'] = requestParameters['merge'];
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/forms/{form_scope}/{resource_id}/{schema_id}`.replace(`{${"form_scope"}}`, encodeURIComponent(String(requestParameters['form_scope']))).replace(`{${"resource_id"}}`, encodeURIComponent(String(requestParameters['resource_id']))).replace(`{${"schema_id"}}`, encodeURIComponent(String(requestParameters['schema_id']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['body'],
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Űrlap írása [ID: WriteFormData]
     */
    writeFormData(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.writeFormDataRaw(requestParameters, initOverrides);
        });
    }
}
